import { render, staticRenderFns } from "./animal1.vue?vue&type=template&id=43185c7e&"
import script from "./animal1.vue?vue&type=script&lang=js&"
export * from "./animal1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports